import { render, staticRenderFns } from "./IconSpeechBubble.vue?vue&type=template&id=3ef4a022&scoped=true&"
import script from "./IconSpeechBubble.vue?vue&type=script&lang=js&"
export * from "./IconSpeechBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4a022",
  null
  
)

export default component.exports